import { formatPercent } from './percent';

export type DeltaTone = 'positive' | 'negative' | 'neutral';

export function deltaTone(delta: number, opts: { invert?: boolean } = {}): DeltaTone {
  if (!Number.isFinite(delta) || delta === 0) return 'neutral';
  const positive = opts.invert ? delta < 0 : delta > 0;
  return positive ? 'positive' : 'negative';
}

export function formatDelta(deltaPct: number): string {
  return formatPercent(deltaPct, { signed: true });
}
